import { SupplierCondition } from "vamos/cockpit/model/odata/VamosModel";
import V4Context from "sap/ui/model/odata/v4/Context";

export default class SupplierConditionDto {
    private _supplierGuid: string;
    private _supplierName: string;
    private _articleName: string;
    private _articleNumber: string;
    private _materialGroupName: string;
    private _supplierConditionContext: V4Context;
    private _productGuid: string;
    private _baseUnitName: string;
    private _baseUnitGuid: string;
    private _articleGuid: string;
    private _productName: string;
    // guid from the initiator : request-> requestGuid , order->orderGuid
    private _originGuid: string;

    constructor(supplierGuid?: string, supplierName?: string, supplierConditionContext?: V4Context, articleName?: string, articleNumber?: string, articleGuid?: string, materialGroupName?: string, productGuid?: string, productName?: string,originGuid?:string, baseUnitName?: string, baseUnitGuid?: string) {
        this._supplierGuid = supplierGuid;
        this._supplierName = supplierName;
        this._supplierConditionContext = supplierConditionContext;
        this._articleName = articleName;
        this._articleNumber = articleNumber;
        this._articleGuid = articleGuid;
        this._materialGroupName = materialGroupName;
        this._productGuid = productGuid;
        this._productName = productName;
        this._originGuid = originGuid;
    }

    public getSupplierConditionContext(): V4Context {
        return this._supplierConditionContext;
    }

    public getArticleGuid(): string {
        return this._articleGuid;
    }

    public getSupplierConditionGuid(): string {
        return this._supplierConditionContext.getProperty("Guid") as string;
    }

    public getSupplierCondition(): SupplierCondition {
        return this._supplierConditionContext.getObject() as SupplierCondition;
    }

    setSupplierGuid(value: string) {
        this._supplierGuid = value;
    }

    setSupplierName(value: string) {
        this._supplierName = value;
    }

    setArticleName(value: string) {
        this._articleName = value;
    }

    setArticleNumber(value: string) {
        this._articleNumber = value;
    }

    setMaterialGroupName(value: string) {
        this._materialGroupName = value;
    }

    public setSupplierConditionContext(value: V4Context) {
        this._supplierConditionContext = value;
    }

    setProductGuid(value: string) {
        this._productGuid = value;
    }

    setBaseUnitName(value: string) {
        this._baseUnitName = value;
    }

    setBaseUnitGuid(value: string) {
        this._baseUnitGuid = value;
    }

    setArticleGuid(value: string) {
        this._articleGuid = value;
    }

    setProductName(value: string) {
        this._productName = value;
    }
    setOriginGuid(value: string) {
        this._originGuid = value;
    }
    getOriginGuid(): string {
        return this._originGuid;
    }

    getSupplierGuid(): string {
        return this._supplierGuid;
    }

    getSupplierName(): string {
        return this._supplierName;
    }

    getArticleName(): string {
        return this._articleName;
    }

    getArticleNumber(): string {
        return this._articleNumber;
    }

    getMaterialGroupName(): string {
        return this._materialGroupName;
    }

    getProductGuid(): string {
        return this._productGuid;
    }

    getBaseUnitName(): string {
        return this._baseUnitName;
    }

    getBaseUnitGuid(): string {
        return this._baseUnitGuid;
    }

    getProductName(): string {
        return this._productName;
    }
}